// src/app/hooks/opening/queries.ts
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGetOpeningParamsQuery, useLazyGetOpeningQuery } from '../../services';
import { useGetAccessoryPosition } from '../ahu';
import { setOpening, setOpeningParams } from '../../slices';

export const useGetOpeningMainData = (id: number) => {
  const { isLoading: accessDoorLoading } = useGetOpening(id);
  const { isLoading } = useGetOpeningParams();
  const {
    isLoading: positionLoading,
    getPosition,
    position,
  } = useGetAccessoryPosition(id);
  return {
    isLoading: isLoading || accessDoorLoading || positionLoading,
    getPosition,
    position,
  };
};

export const useGetOpening = (id: number, fetch = true) => {
  const dispatch = useDispatch();
  const [getOpening, { data: opening, isLoading }] = useLazyGetOpeningQuery();

  useEffect(() => {
    if (fetch && id) {
      getOpening(id);
    }
  }, [id]);

  useEffect(() => {
    if (opening) dispatch(setOpening(opening));
  }, [opening]);

  return {
    opening,
    isLoading,
    getOpening,
  };
};

export const useGetOpeningParams = () => {
  const dispatch = useDispatch();

  const { data: params, isLoading, refetch } = useGetOpeningParamsQuery();

  useEffect(() => {
    if (params) {
      dispatch(setOpeningParams(params.opening));
    }
  }, [params]);

  return { isLoading, params, get: refetch };
};
